module.exports = __webpack_public_path__ + "img/preview.6dba6640.png";